import type {View, ViewColProps, ViewProps} from "./View";
import type {ColType} from "@t/agenda/Columns";

export interface Options {
	[key: string] : any
}

export interface AgendaData<T> {
    total: number;
    position: number;
    size: number;
    orderBy?: string;
    desc?: boolean;
    items: T[];
	/** Extra data which can be packed in */
	meta?: Options;
}

export interface AgendaClass {
	/** Agenda class name */
	agenda: string;
	/** Entity class name */
	entity?: string;
}

export interface Agenda extends AgendaClass{
    /** Saved view ID */
    id?: number;
    view: View
}


export interface AgendaReference extends AgendaClass {
    view: ViewColProps
}

export interface AgendaRegistryEntry extends AgendaReference {
    name: string;
	/** Type of column containing reference to this agenda */
    type?: ColType;
    references?: AgendaReference[];
}

export interface AgendaDescriptor extends AgendaClass {
    props?: ViewProps;
}

export function referenceToDescriptor(ref: AgendaReference): AgendaDescriptor {
	const desc: AgendaDescriptor = {
		agenda: ref.agenda,
	};
	if (ref.entity) desc.entity = ref.entity;
	if (ref.view && ref.view.props) {
		desc.props = { ...ref.view.props };
	}
	return desc;
}